var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"pre__modal",on:{"click":_vm.close}},[_c('img',{staticClass:"pre_img",attrs:{"src":_vm.src}})])}
var staticRenderFns = []

export { render, staticRenderFns }